import React from 'react'
import moment from 'moment'
import Spinner from '../../common/spinner-container'
import { sortBy, reverse } from 'lodash'
import ListItem from '../../experience/details-card'
import useUserCourses from '../../../hooks/use-user-year-courses'

const ScheduleList = () => {

    const { courses: userCourses, isLoading } = useUserCourses()
    const today = moment()
    const courses = sortBy(userCourses.filter(c => moment(c.date).isSameOrAfter(today)), ['date'])

    if (isLoading) {
        return (<Spinner />)
    }

    if (!courses.length ) {
        return (
            <div>
                <div className='text-center'>
                    <h3><strong>You currently have no upcoming experiences.</strong></h3>
                </div>
                <div className='text-center'>
                    Enroll in a new experience below.
                </div>
            </div>
        )
    }

    const renderCourse = (course, key) => {
        return (
            <div key={key} style={{ paddingTop: '10px'}} >
                <ListItem experience={course} />
            </div>
        )
    }

    return (
        <React.Fragment>
            {courses.map(renderCourse)}
        </React.Fragment>
    )
}

export default ScheduleList